export default "/images/disc.svg?2ff64a52f8a9e6470c02f3a8231dac8d";